// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"e943d734","910":"a3e8e4cf"}[chunkId] + ".chunk.js";
};